import React, { useState } from 'react'
import { ZinButton } from '@tnl/zin-react'
import { MkRentalOptionsModal } from '@features/book/components/RentalOptionsModal/MkRentalOptionsModal'
import { BookProvider } from '@features/book/contexts/core/_provider'

/**
 * Test page for MkRentalOptionsModal component
 *
 * This page provides a comprehensive testing environment for the rental options modal,
 * including different data scenarios and interaction testing.
 */
const MkRentalOptionsModalTest: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  // Mock payment options data with optionLabel and details array
  const mockPaymentOptions = [
    {
      optionLabel: 'Renting Points',
      details: [
        { label: 'Overview', value: 'Get extra points for a small fee' },
        { label: '10 to 3 months prior to arrival', value: "For part of your last night's stay" },
        { label: 'Cost', value: '$12 per 1,000 points' },
        { label: 'Exclusions', value: 'Points available for rent are limited to your annual allocation.' },
      ],
    },
  ]

  const handleOpenModal = () => {
    setIsModalVisible(true)
  }

  const handleCloseModal = () => {
    setIsModalVisible(false)
  }

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>MkRentalOptionsModal Test</h1>
      <p style={{ marginBottom: '2rem' }}>Click the button below to open the rental options modal</p>

      <ZinButton
        variant="primary"
        onClick={handleOpenModal}
        icon="calendar-range"
        iconPosition="left">
        Open Rental Options Modal
      </ZinButton>

      {/* Render the modal with BookProvider context */}
      <BookProvider>
        <MkRentalOptionsModal
          visible={isModalVisible}
          onHide={handleCloseModal}
          paymentOptions={mockPaymentOptions}
        />
      </BookProvider>
    </div>
  )
}

export default MkRentalOptionsModalTest
